import { Svg } from '@repo/ui';

import ErrorBaseView, { ErrorBaseViewController } from '@/components/tax-refund/common/view/ErrorView/ErrorBaseView';

interface Props {
  disabledPrimaryButton?: boolean;
  onPrimaryButtonClick: () => void;
}

const NetworkError = ({ onPrimaryButtonClick, disabledPrimaryButton = false }: Props) => {
  const errorBaseViewController: ErrorBaseViewController = {
    graphic: <Svg src="icg_wifi-exclamation-mark_md.svg" width={80} height={80} />,
    title: '인터넷 연결이 끊어졌어요',
    description: '인터넷 연결 확인 후\n다시 시도해주세요.',
    primaryButtonText: '다시 시도',
    onPrimaryButtonClick: onPrimaryButtonClick,
    disabledPrimaryButton: disabledPrimaryButton,
    primaryButtonVariant: 'tonal-secondary'
  };

  return <ErrorBaseView viewController={errorBaseViewController} />;
};

export default NetworkError;
